import React from "react";
import styled from "styled-components";

const SubtitleStyled = styled.h3(
  ({ color, theme }) => `
    font-size: 16px;
    font-weight: 600;
    color: ${theme.colors[color] || theme.colors.orange};
    text-align: center;
    margin-bottom: -10px;
`
);

export const Subtitle = ({ color, children, ...props }) => (
  <SubtitleStyled color={color} {...props}>
    {children}
  </SubtitleStyled>
);
